module.exports = {"620302001":"滨河路街道","620302002":"桂林路街道","620302003":"北京路街道","620302004":"金川路街道","620302005":"新华路街道","620302006":"广州路街道","620302100":"宁远堡镇","620302101":"双湾镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620302.json
// module id = 2900
// module chunks = 0